<template>
  <ed-modal :show="showModal"
            :title="title"
            @close="$emit('close')"
            @beforeshow="onShow" type="medium" flat>
    <div class="content" slot="body">
      <itemsList :list="list" :programLabel="programLabel"/>

      <div class="row bottom-row">
        <ed-textarea class="col-md-7 row"
                      v-model="reason"
                      field-label="Reason"
                      :placeholder="subtitle"
                      :maxlength="1000"
                      :rows="4"
                      required
                      autofocus
                      :error="error"
                      ref="reasonInput"
                      @input="validate" />
        <userInfo :title="rejectText" />
        <ed-checkbox
          v-if="!isEvedPayCardPresent"
          class='col-md-7'
          @click='changeNotifySupplier'
          :options='notifySupplierOption'
          name='notify_supplier'
          :helptip-body="notifySupplierOption[0].label"
        >
        </ed-checkbox>
      </div>
    </div>

    <div class="buttons clear" slot="footer">
      <ed-button button-class="btn btn-default" @click="$emit('close')">Cancel</ed-button>
      <ed-button @click="reject">{{rejectText}}</ed-button>
    </div>
  </ed-modal>
</template>

<script>
  import itemsList from './items-list'
  import userInfo from './user-info'

  export default {
    props: {
      showModal: Boolean,
      rejectText: String,
      list: Array,
      programLabel: String
    },

    data() {
      return {
        reason: '',
        notifySupplier: false,
        error: false,
        notifySupplierOption: [
          {
            label: 'Notify Supplier',
            status: this.notifySupplier
          }
        ]
      }
    },

    computed: {
      rejectLabelGerundLowerCase() {
        return 'declining'
      },

      title() {
        return 'You are about to ' + (this.rejectText || '').toLowerCase() + ((this.list.length === 1) ? ' this item' : ' these items')
      },

      subtitle() {
        return 'Enter your reason for ' + this.rejectLabelGerundLowerCase + ((this.list.length === 1) ? ' this item' : ' these items')
      },

      isEvedPayCardPresent() {
        return this.list.some(item =>
          item.NeedsApproval.includes('Add Card Request') ||
          item.NeedsApproval.includes('Funds Request') ||
          item.NeedsApproval.includes('Refill Setting') ||
          item.NeedsApproval.includes('EvedPay Envelope') ||
          item.NeedsApproval.includes('ER')
        )
      }
    },

    methods: {
      onShow() {
        this.reason = ''
        this.notifySupplier = false
        this.notifySupplierOption[0].status = false
        this.error = false
      },

      changeNotifySupplier(e) {
        if (!e.status) {
          this.notifySupplier = false
        } else {
          this.notifySupplier = true
        }
      },

      validate() { this.error = (this.reason === '') },

      reject() {
        this.validate()

        if (this.error) {
          this.$refs.reasonInput.$refs.input.focus()
        } else {
          this.$emit('reject', this.reason, this.notifySupplier)
          this.$emit('close')
        }
      }
    },

    components: { itemsList, userInfo }
  }
</script>

<style lang="scss" scoped>

.bottom-row.bottom-row.bottom-row.bottom-row {
  margin-left: -15px;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ApprovalNeeded/reject-dialog.vue